import {Form} from "../../../../model/form/form";
import {SyntheticItem} from "../../../../model/items/synthetic";
import m, {Vnode} from "mithril";

export default class ValidationBox {

    private readonly synthetics: SyntheticItem[] = [];

    private lastVisibleMessage: string|null = null;

    constructor(
        public readonly form: Form
    ) {
        for (const cell of form.grid.cells) {
            for (const cellItem of cell.cellItems) {
                if (cellItem instanceof SyntheticItem) {
                    this.synthetics.push(cellItem);
                }
            }
        }
    }

    public view(): Vnode|null {

        let firstError = '';
        for (const synthetic of this.synthetics) {
            if (!synthetic.cell.valid) {
                firstError = synthetic.cell.validate().messages[0];
            }
        }

        // When there is no longer errors keep error text (but hidden) to prevent content jumping
        if (this.synthetics.length === 0 || (!firstError && !this.lastVisibleMessage)) {
            return null;
        }

        if (firstError) {
            this.lastVisibleMessage = firstError;
        }

        const hide = !firstError && this.lastVisibleMessage;
        const text = firstError || this.lastVisibleMessage || '';

        return m('.validationBox'+(hide?'.invisible':''), {}, this.form.questionary.renderText(text));
    }

}